<template>
  <div class="video-item">
    <div class="row">
      <div class="col col-xs-6">
        <div class="form-group">
          <label>Заголовок</label>
          <input type="text" required class="form-control" v-model="video.title">
        </div>
      </div>
      <div class="col col-xs-6">
        <div class="form-group">
          <label>Идентификатор или URL</label>
          <input type="text" required class="form-control" v-model="video.id">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col col-xs-6">
        <div class="form-group">
          <label>Описание</label>
          <textarea class="form-control" v-model="video.description"></textarea>
        </div>
      </div>
      <div class="col col-xs-6">
        <button class="btn btn-outline-danger" @click.prevent="deleteVideo(index)"><i class="icon-fa icon-fa-trash"/> Удалить видео</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['index', 'video', 'deleteVideo'],
}
</script>

<style scoped>
  .video-item:not(:last-child) {
    border-bottom: 1px solid gainsboro;
    margin-bottom: 20px;
    padding-bottom: 13px;
  }
</style>
